const CONTROLES = "button, a, input, label, i, .el-checkbox, .el-link, .el-tag";

const RowModalMixin = {
  data() {
    return {
      rowModal: {
        tag: "",
        open: false,
      },
    };
  },
  methods: {
    openRowModal(row, column, event) {
      if (!row || !row.tag) {
        return;
      }

      if (!column || column.type === "selection" || !column.property) {
        return;
      }

      const alvo = event && event.target;
      if (alvo && alvo.closest && alvo.closest(CONTROLES)) {
        return;
      }

      if (window.getSelection) {
        window.getSelection().removeAllRanges();
      }

      this.rowModal = { tag: row.tag, open: true };
    },
    closeRowModal() {
      this.rowModal = { tag: "", open: false };
    },
  },
};

export default RowModalMixin;

export { RowModalMixin };
